module.exports = __webpack_public_path__ + "media/site/images/products/saas_oeetools-screen2-de1bffb4d783c61c8aa174d0fd454dd3.png";